import styled, {keyframes} from 'styled-components'

const appearFromTop = keyframes`
from {
  opacity: 0;
  transform: translateY(-100px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`

const appearFromDown = keyframes`
from {
  opacity: 0;
  transform: translateY(50px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`

const appearFromLeft = keyframes`
from {
  opacity: 0;
  transform: translateX(-100px);
}
to {
  opacity: 1;
  transform: translateX(0);
}
`

const appearFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(100px);
}
to {
  opacity: 1;
  transform: translateX(0);
}
`

const FadeInAnimation = keyframes`  
  from { opacity: 0; }
  to { opacity: 1; }
`

const heartBeat = keyframes`
  0%
  {
    transform: scale( 1 );
  }
  25%
  {
    transform: scale( .98 );
  }
  50%
  {
    transform: scale( 1 );
  }
  75%
  {
    transform: scale( .98 );
  } 
  100%
  {
    transform: scale( 1 );
  }
`;



export const AnimaDireita = styled.section`
  animation: ${appearFromRight} 2s;
`
export const AnimaDireita2 = styled.section`
  animation: ${appearFromRight} 2s;
`

export const AnimaEsquerda = styled.section`
  animation: ${appearFromLeft} 2s;
`

export const AnimaCima = styled.section`
  animation: ${appearFromTop} 2s;
`
export const AnimaCima2 = styled.section`
  animation: ${appearFromTop} 0.5s;
`

export const AnimaBaixo = styled.section`
  animation: ${appearFromDown} 2s;
`

export const AnimaFadein = styled.section`  
  animation: ${FadeInAnimation} 4s;
`
export const AnimaFadeininput = styled.section`
  width: 100%;  
  animation: ${FadeInAnimation} 2s;
`

export const AnimaFadeinTop = styled.section`
  animation: ${FadeInAnimation} 1s;
  margin-top: -5px;
`
export const AnimaBaixo2 = styled.section`
  animation: ${appearFromDown} 0.5s;
  margin-top: -5px;
`
export const AnimaPulse = styled.section`
  animation: ${heartBeat} 3s infinite;
`;

export const AnimaPulse2 = styled.section`
  animation: ${heartBeat} 4s infinite; 
  position: relative;
`;

